import { Typography, Box } from "@mui/material";
import { useAppContext } from "../../context/appContext";
import { useEffect, useState } from "react";

export const RightBox = ({ type, admins = [], users = [] }) => {
  const { isMobile } = useAppContext();
  const [selectedAdmins, setSelectedAdmins] = useState([]);

  // for EventManager Title
  useEffect(() => {
    if (admins?.length && users?.length > 0) {
      const selected = users.filter((u) => admins.includes(u.id));
      setSelectedAdmins(selected);
    } else {
      setSelectedAdmins([]);
    }
  }, [admins, users]);

  // ✅ shared layout
  const containerStyle = {
    flex: 1,
    textAlign: "end",
    whiteSpace: "nowrap",
  };

  const defaultContent = (
    <Box>
      <Typography variant="h6" color="primary">
        Viel Vergnügen
      </Typography>
      <Typography color="primary" variant="h4" fontWeight="bold">
        KSB-IT
      </Typography>
    </Box>
  );

  const contentMap = {
    chatApp: defaultContent,

    bszFinder: (
      <Box>
        <Typography variant="h6" color="primary">
          Wer? Wo? Was?
        </Typography>
        <Typography color="primary" variant="h4" fontWeight="bold">
          BSZ Finder
        </Typography>
      </Box>
    ),

    bszPlanner: (
      <Box>
        <Typography variant="h6" color="primary">
          Was tun?
        </Typography>
        <Typography color="primary" variant="h4" fontWeight="bold">
          BSZ Planner
        </Typography>
      </Box>
    ),

    sondertageApp: (
      <Box>
        <Typography variant="h6" color="primary">
          Reserviere
        </Typography>
        <Typography color="primary" variant="h4" fontWeight="bold">
          Dein Projekt
        </Typography>
      </Box>
    ),

    eventManagerApp: !isMobile ? (
      <Box>
        <Typography variant="h6" color="primary">
          Administratoren
        </Typography>
        <Typography color="primary" variant="h4" fontWeight="bold">
          {selectedAdmins
            ?.slice() // avoid mutating state/props
            .sort((a, b) => a.abbreviation.localeCompare(b.abbreviation))
            .map((a) => a.abbreviation)
            .join(", ")}{" "}
        </Typography>
      </Box>
    ) : null,

    profile: null,

    admin: !isMobile ? (
      <Box>
        <Typography variant="h6" color="primary">
          Plattform
        </Typography>
        <Typography color="primary" variant="h4" fontWeight="bold">
          Übersicht
        </Typography>
      </Box>
    ) : null,

    askoma: (
      <Box>
        <Typography variant="h6" color="primary">
          Energieverbrauch
        </Typography>
        <Typography color="primary" variant="h4" fontWeight="bold">
          Heizeinsatz
        </Typography>
      </Box>
    ),
  };

  return <Box sx={containerStyle}>{contentMap[type] ?? defaultContent}</Box>;
};
